import React from "react";

function UnAuthorisedUser(props) {
  let message = props.message;
  return (
    <div className="container">
      <div className="panel-body">
        <p style={{ color: "red", textAlign: "center" }}>{message}</p>
      </div>
    </div>
  );
}

export default UnAuthorisedUser;
